import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Header,
  Label,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import BookingsList from '../../../components/BookingsList';
import { TRANSLATION_FILES } from '../../../constants/translation';

class Bookings extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    isMobile: PropTypes.bool,
    loading: PropTypes.bool,
    unitID: PropTypes.string,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  });
  constructor(props) {
    super(props);
    this.state = {
      bookingListLength: 0,
      collapseSegments: [{
        hideBookings: false,
      }],
    };
  }
  checkIsAgent = () => {
    const auth = this.props.auth;
    if (auth &&
    auth.companyBranch &&
    auth.companyBranch.isExternal &&
    auth.isDeveloper &&
    !auth.isSuperAdmin &&
    !auth.isHeadquarters &&
    !auth.isBranchLeader) {
      return true;
    }
    return false;
  }
  handlebookingListLength = (length) => {
    this.setState({ bookingListLength: length });
  }
  handleOnCollapseSegment = (e, { name, value }) => {
    const { collapseSegments } = this.state;
    e.preventDefault();
    collapseSegments[name] = !value;
    this.setState({ collapseSegments });
  }

  render() {
    const { isMobile, t } = this.props;
    const { hideBookings } = this.state.collapseSegments;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
            { (this.state.bookingListLength === 0 && this.checkIsAgent()) ?
              '' :
              <Header
                className="new_title"
                as="h5"
                textAlign="center"
                attached="top"
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={16} textAlign="center">
                      {t('Bookings').toUpperCase()}
                    </Grid.Column>
                    <Label
                      as="button"
                      attached="top right"
                      icon={hideBookings ? 'angle up' : 'angle down' }
                      className="collapse-button"
                      style={{
                        position: 'absolute',
                        right: '0',
                        top: '3px',
                        marginRight: '0',
                        marginTop: '0.5em',
                      }}
                      name="hideBookings"
                      value={hideBookings}
                      onClick={this.handleOnCollapseSegment}
                      disabled={this.props.loading}
                    />
                  </Grid.Row>
                </Grid>
              </Header>
            }
            {
              !hideBookings ? (
                <Segment attached>
                  <BookingsList
                    isUnitOverview
                    projectUnitID={this.props.unitID}
                    noScrollTop
                    hideBookingList={this.checkIsAgent()}
                    bookingListLength={this.handlebookingListLength}
                  />
                </Segment>
              ) : null
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(connect(Bookings.mapStateToProps)(Bookings));



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Bookings.jsx